module.exports = __webpack_public_path__ + "img/IMG-truck-bg2.8ff4abae.png";